// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"8bea5d48ec4a3e7a","888":"7e1d1c811d69aeda"}[chunkId] + ".css";
};